import $ from 'jquery';

$('.js-accor').each(function () {
	$('.js-accor-heading', this).on('click', function () {
		$(this).closest('.js-accor').toggleClass('is-open');
		$(this).closest('.js-accor').find('.js-accor-content').slideToggle();
	});
});
